module.exports = __webpack_public_path__ + "5ce046b21504eec7afcb4fd138f1e83a.svg";